import { UserFlags } from '@ordermentum/ui-types';
import { Map } from 'immutable';

export const getPurchasersUrl = (flags = Map()) =>
  flags.getIn(['data', 'marketplaces_endpoint_v2'])
    ? '/v2/marketplaces'
    : '/v1/purchasers';

export const getPurchasersUrlV2 = (flags: UserFlags) =>
  flags.marketplaces_endpoint_v2 ? '/v2/marketplaces' : '/v1/purchasers';
